import Hero from "@/components/home/Hero";
import Marquee from "@/components/home/Marquee";
import Mission from "@/components/home/Mission";
import Pillars from "@/components/home/Pillars";
import SupportoPsicologico from "@/components/home/SupportoPsicologico";
import GuidePreview from "@/components/home/GuidePreview";
import OttoPerMille from "@/components/home/OttoPerMille";
import Sedi from "@/components/home/Sedi";
import CtaBand from "@/components/home/CtaBand";

export default function Home() {
  return (
    <>
      <Hero />
      <Marquee />
      <Mission />
      <Pillars />
      <SupportoPsicologico />
      <GuidePreview />
      <OttoPerMille />
      <Sedi />
      <CtaBand />
    </>
  );
}
